<div class="row form" *ngIf="book != null">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-4">
          <h4 class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>Detalle traspaso</h4>
        </div>
        <div class="col-sm-8 form__head__boxBtn">
          <button type="button" class="btn btn-secondary btn-sm" (click)="cancel()"><i
              class="fas fa-arrow-left m-r-5"></i> Regresar
          </button>
          <a type="button" class="btn btn-danger btn-sm text-white" (click)="delete(book)">
           <i class="far fa-trash-alt m-r-2"></i> Eliminar
          </a>
          <button type="button" class="btn btn-light btn-sm" (click)="printer()">
            <i class="fas fa-print m-r-3"></i> Imprimir
          </button>
          <button class="btn btn-sm btn-primary" *ngIf="book.is_checkout == false" (click)="edit(book.id)"><i
              class="fas fa-pen-alt m-r-2"></i>Editar
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-50" id="body">
      <div class="card-body faq-box boder-left-{{book.status_booking.class}}">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Estado</div>
                <div class="child-right">
                  <span class="badge f-s-12 badge-{{book.status_booking.class}}">{{book.status_booking.message}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Código traspaso</div>
                <div class="child-right">
                  <span class="bold" style="color: red !important;">{{book.code}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Agencia Traspasado</div>
                <div class="child-right">
                  <span class="bold">{{book.agency_data.tradename}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left bold">Origen Reserva</div>
                <div class="child-right">
                  <p class="bold f-s-10 m-b-0">COD:{{bookingSelected.code}}</p>
                  {{bookingSelected.client_data.fullname}}
                  <p class="bold f-s-10 m-b-0">{{bookingSelected.client_data.typeDocument}} :
                    {{bookingSelected.client_data.document}}</p>
                  <p class="bold f-s-10 m-b-0">CEL :{{bookingSelected.client_data.cellphone}}</p>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                <div class="child-left">Observaciones</div>
                <div class="child-right">
                  {{book.observations}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <p class="form__group__title m-b-0 f-s-12"><i class="fas fa-map-marker-alt m-r-5"></i>Datos de tours
          </p>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Nombre tours</th>
                  <th class="text-center">N° PAX</th>
                  <th>Vehículo</th>
                  <th>Turno</th>
                  <th>F. asignada</th>
                  <th class="text-center">Precio corporativo</th>
                  <th class="text-center">Cobranza delegada
                    <i class="fas fa-info-circle m-l-5"
                      uib-tooltip="Si hay alguna cobranza delegada al operador, importante! en el cuadre de agencias"></i>
                  </th>
                  <th></th>
                  <!-- <th class="text-center">
                    Observación
                  </th> -->
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="tours.length == 0">
                  <tr>
                    <td colspan="6"><span>No se encontraron registros</span></td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="tours.length > 0">
                  <tr *ngFor="let item of tours; let index_ = index" [ngClass]="{'text-open': item.is_open}">
                    <td>
                      {{item.description}}                      
                    </td>
                    <td class="text-center">{{item.quantity}}</td>
                    <td>
                      <span
                        class="badge f-s-10 badge-{{item.vehicle_tour_content.class}}">{{item.vehicle_tour_content.description}}</span>
                    </td>
                    <td><span class="bold">{{item.shift_tour_content.description}}</span></td>
                    <td>{{item.date_assigned | date: 'mediumDate'}}</td>
                    <td class="text-center">{{item.price_corporate}}</td>
                    <td class="text-center">{{item.delegated_payment}}</td>
                    <td class="text-center">
                      <div *ngIf="item.is_paid">
                        <span  class="badge badge-dark f-s-10">Reportado</span>
                      </div>
                    </td>
                    <!-- <td class="text-center">{{item.observation}}</td> -->
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
